module.exports = __webpack_public_path__ + "static/media/shape01a.cb990359.svg";